import { CONFERENCE_LEFT } from '../base/conference/actionTypes';
import { ReducerRegistry } from '../base/redux';

import { SET_ANNOTATION_DRAWING, SET_REMOTE_ANNOTATION_ALLOWED } from './actionTypes';

const DEFAULT_STATE = {
    /**
     * Whether viewers may draw on the local participant's screen share.
     */
    allowed: true,

    /**
     * Whether the local viewer is in drawing mode on the large video.
     */
    drawing: false
};

ReducerRegistry.register('features/screen-annotation', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case SET_ANNOTATION_DRAWING:
        return {
            ...state,
            drawing: action.drawing
        };

    case SET_REMOTE_ANNOTATION_ALLOWED:
        return {
            ...state,
            allowed: action.allowed
        };

    case CONFERENCE_LEFT:
        return DEFAULT_STATE;
    }

    return state;
});
